import { createTheme } from '@mui/material';

/**
 * Dark theme for the Media Buying Report
 */
export const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#90caf9',
        },
        secondary: {
            main: '#f48fb1',
        },
        background: {
            default: '#1e2130',
            paper: '#2c3040',
        },
        text: {
            primary: '#ffffff',
            secondary: 'rgba(255, 255, 255, 0.7)',
        },
    },
    components: {
        MuiPickersDay: {
            styleOverrides: {
                root: {
                    color: '#fff',
                    '&.Mui-selected': {
                        backgroundColor: '#90caf9',
                        color: '#1e2130',
                        fontWeight: 'bold',
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    color: '#fff',
                    borderColor: 'rgba(255, 255, 255, 0.3)',
                    '&:hover': {
                        borderColor: 'rgba(255, 255, 255, 0.5)',
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    },
                    '&.Mui-selected': {
                        backgroundColor: '#90caf9',
                        color: '#1e2130',
                        fontWeight: 'bold',
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    color: '#fff',
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(255, 255, 255, 0.3)',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(255, 255, 255, 0.5)',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#90caf9',
                    },
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: 'rgba(255, 255, 255, 0.7)',
                    '&.Mui-focused': {
                        color: '#90caf9',
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: '#2c3040',
                    color: '#fff',
                },
            },
        },
        MuiPickersCalendarHeader: {
            styleOverrides: {
                root: {
                    color: '#fff',
                },
                iconButton: {
                    color: 'rgba(255, 255, 255, 0.7)',
                    '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    },
                },
            },
        },
        MuiPickersDay: {
            styleOverrides: {
                root: {
                    color: '#fff',
                    '&.Mui-selected': {
                        backgroundColor: '#90caf9',
                        color: '#1e2130',
                    },
                },
            },
        },
        MuiButtonBase: {
            styleOverrides: {
                root: {
                    color: '#fff',
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    color: 'rgba(255, 255, 255, 0.7)',
                    '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    },
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    color: 'rgba(255, 255, 255, 0.7)',
                },
            },
        },
        MuiPickersToolbar: {
            styleOverrides: {
                root: {
                    color: '#fff',
                    backgroundColor: '#1e2130',
                },
            },
        },
        MuiPickersToolbarText: {
            styleOverrides: {
                root: {
                    color: '#fff',
                },
            },
        },
        MuiPickersToolbarButton: {
            styleOverrides: {
                root: {
                    color: '#fff',
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    backgroundColor: '#1e2130',
                },
            },
        },
    },
}); 